import { render, staticRenderFns } from "./UpdatePasswordEmail.vue?vue&type=template&id=749fda0b&"
import script from "./UpdatePasswordEmail.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports